export default {
  NOT_EXPIRED: 'notExpired',
  TOKEN_EXPIRED: 'tokenExpired',
  CARD_EXPIRED: 'cardExpired',
  INVALID_EXPIRATION_DATE: 'invalidExpirationDate',
};
